import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const useAuthStore = create(
  devtools(
    (set) => ({
      jwt: null,
      setJwt: (jwt) => {
        set({ jwt }, false, 'AUTH/SET_JWT');
      },
    }),
    { name: 'AuthStore' },
  ),
);
